module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='195' height='166' viewBox='0 0 195 166'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cpath fill='%23D7D7D7' d='M73.275 0L-6 179.483h47.94L121.45 0z'/%3E %3Cpath fill='%23E0E0E0' d='M73.458 0l79.51 179.483h47.94L121.634 0z'/%3E %3C/g%3E %3C/svg%3E\""


//////////////////
// WEBPACK FOOTER
// ./src/assets/url/a-on-black.svg
// module id = ./src/assets/url/a-on-black.svg
// module chunks = 4